export const logout = {
  success: 'You’ve Successfully Logged Out.',
  action: 'Back to Home'
};
